import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton';
import { ReactNode, Ref } from 'react';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { AnyRouter, createLink, LinkOptions, RegisteredRouter } from '@tanstack/react-router';
import { useIsRouteMatching } from '@/common/hooks/useIsRouteMatching.ts';

const ListItemLinkComponent = (props: ListItemButtonProps<'a'>) => (
  <ListItemButton {...props} component="a" />
);

const ListItemLink = createLink(ListItemLinkComponent);

type NavMenuLinkProps<
  TRouter extends AnyRouter = RegisteredRouter,
  TFrom extends string = string,
  TTo extends string | undefined = '.',
  TMaskFrom extends string = TFrom,
  TMaskTo extends string = '.',
> = Omit<LinkOptions<TRouter, TFrom, TTo, TMaskFrom, TMaskTo>, ''> & {
  icon: ReactNode;
  label: ReactNode;
  ref?: Ref<HTMLAnchorElement>;
};

export const NavMenuLink = ({ icon, label, ...rest }: NavMenuLinkProps) => {
  const isActive = useIsRouteMatching({ to: rest.to, fuzzy: true });

  return (
    <ListItemLink {...rest} selected={isActive}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItemLink>
  );
};
